import { RuleValidationMessage } from "~app/common/services/cqs/models/rule-validation-message";
import { VirkeskopskontraktPrisDTO } from "../../dto/pristabell/pristabell-dtos";
import { VardeberakningRequestDTO } from "../../dto/vardeberakning/vardeberakning-request-dto";
import { PristabellRad } from "../pristabell/pristabell-models";

export interface VKUtskriftValuesDTO {
    utskrift: VirkeskopskontraktUtskriftDTO;
    validationMessages: RuleValidationMessage[];
}

export interface VirkeskopskontraktUtskriftDTO {
    id?: number;
    kontraktId: number;
    drivningskostnad?: number;
    arealSlutavvUtanFrotrad?: number;
    arealSlutavvMedFrotrad?: number;
    arealOverstandare?: number;
    arealGallring?: number;
    arealOvrigAvverkning?: number;
    kontraktTotalKvantitet?: number;
    kontraktsbelopp?: number;
    visaKontraktsbeloppIUtskrift: boolean;
    ovrigtOverenskommet: string;
    makeGodkannandeKravsEj?: boolean;
    leveransvirkesplanIUtskrift?: boolean;
    ersattningstyp?: ErsattningsTyp;
    stamplingsLangdUpprattatDatum?: string;
    stamplingsLangdUpprattatAv: string;
    stamplingsLangdAntalTrad?: number;
    kontraktsbeloppUtskrivet: string;
    pristabell?: VirkeskopskontraktPrisDTO[];
    anteckningSkogsvard?: string;
}

export interface CreateVirkeskopskontraktUtskriftRequestDTO {
    affarsform: string;
    nettotyp: string;
    skordarmatning?: boolean;
    vardeberakningRequest: VardeberakningRequestDTO;
    currentPristabell: VirkeskopskontraktPrisDTO[];
}

export interface GetVKAtgardExtraKartinfoQuery {
    atgardId?: number;
    geometri: string;
}

export enum ErsattningsTyp {
    Nettovolym = "Nettovolym",
    Bruttovolym = "Bruttovolym"
}

const mapPristabell = (pristabell: VirkeskopskontraktPrisDTO[]) =>
    pristabell.map(x => new PristabellRad(x));

export class KontraktUtskriftValues {
    stamplingsLangdUpprattatDatum?: string;
    stamplingsLangdUpprattatAv: string;
    stamplingsLangdAntalTrad?: number;
    kontraktsbelopp?: number;
    visaKontraktsbeloppIUtskrift: boolean;
    kontraktsbeloppUtskrivet: string;
    ovrigtOverenskommet: string;
    makeGodkannandeKravsEj?: boolean;
    kontraktId: number;
    pristabell: PristabellRad[];
    leveransvirkesplanIUtskrift?: boolean;
    drivningskostnad?: number;
    arealSlutavvUtanFrotrad?: number;
    arealSlutavvMedFrotrad?: number;
    arealOverstandare?: number;
    arealGallring?: number;
    arealOvrigAvverkning?: number;
    kontraktTotalKvantitet?: number;
    ersattningstyp?: ErsattningsTyp;

    constructor(dto?: VirkeskopskontraktUtskriftDTO, kontraktId = dto.kontraktId) {
        this.kontraktId = kontraktId;
        this.stamplingsLangdUpprattatDatum = dto?.stamplingsLangdUpprattatDatum;
        this.stamplingsLangdUpprattatAv = dto?.stamplingsLangdUpprattatAv;
        this.stamplingsLangdAntalTrad = dto?.stamplingsLangdAntalTrad;
        this.kontraktsbelopp = dto?.kontraktsbelopp;
        this.visaKontraktsbeloppIUtskrift = dto?.visaKontraktsbeloppIUtskrift;
        this.kontraktsbeloppUtskrivet = dto?.kontraktsbeloppUtskrivet;
        this.ovrigtOverenskommet = dto?.ovrigtOverenskommet ?? "";
        this.makeGodkannandeKravsEj = dto?.makeGodkannandeKravsEj;
        this.leveransvirkesplanIUtskrift = dto?.leveransvirkesplanIUtskrift;
        this.drivningskostnad = dto?.drivningskostnad;
        this.arealSlutavvUtanFrotrad = dto?.arealSlutavvUtanFrotrad;
        this.arealSlutavvMedFrotrad = dto?.arealSlutavvMedFrotrad;
        this.arealOverstandare = dto?.arealOverstandare;
        this.arealGallring = dto?.arealGallring;
        this.arealOvrigAvverkning = dto?.arealOvrigAvverkning;
        this.kontraktTotalKvantitet = dto?.kontraktTotalKvantitet;
        this.ersattningstyp = dto?.ersattningstyp;
        this.pristabell = mapPristabell(dto?.pristabell ?? []);
    }

    toDto(): VirkeskopskontraktUtskriftDTO {
        return {
            ...this,
            pristabell: this.pristabell.map(x => x.toDto())
        };
    }
}
